import { create, show, useModal } from "@ebay/nice-modal-react";
import { useMutation } from "@apollo/client/react";

import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";
import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";

import { DELETE_AUDIT_TRAIL_WEBHOOK, GET_AUDIT_TRAIL_WEBHOOK } from "../gql";

const AuditTrailDeleteConfirmation = create(function AuditTrailDeleteConfirmation() {
  const modal = useModal();
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const [deleteWebhook, { loading }] = useMutation(DELETE_AUDIT_TRAIL_WEBHOOK, {
    refetchQueries: [{ query: GET_AUDIT_TRAIL_WEBHOOK }],
  });

  const handleConfirm = () => {
    deleteWebhook()
      .then(() => {
        modal.resolve();
        modal.hide();
        reportSuccess({ message: "Audit trail integration successfully disabled" });
      })
      .catch(onError);
  };

  return (
    <DeleteConfirmationModal
      title="Delete audit trail"
      onConfirm={handleConfirm}
      isLoading={loading}
      isDismissable={!loading}
    >
      <ConfirmationModalMessage>
        By deleting the audit trail you will stop receiving audit event webhooks.
      </ConfirmationModalMessage>
    </DeleteConfirmationModal>
  );
});

export const showAuditTrailDeleteConfirmation = () => show(AuditTrailDeleteConfirmation);
